import { Background, BackgroundWrapper } from './HeaderBackground.styled'

export type HeaderBackgroundProps = {
  imageUrl?: Nullable<string>
  defaultImageUrl?: string
}

const HeaderBackground: React.FC<HeaderBackgroundProps> = ({ imageUrl, defaultImageUrl }) => {
  return (
    <BackgroundWrapper defaultImageUrl={defaultImageUrl} data-test='HeaderBackground'>
      <Background imageUrl={imageUrl} />
    </BackgroundWrapper>
  )
}

export default HeaderBackground
